/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import { EducationalInfo } from '../EducationalInfo/EducationalInfo';
import { AdditionalDetails } from '../AdditionalDetails/AdditionalDetails';
import { getSupplementVideos } from '../Helper';

const { arrayOf, node } = PropTypes;

const EducationalSummaryContent = ({
  itemId, showDetails = false, children = null, maxVideos = null, product
}) => {

  const {
    video
  } = product?.media || [];

  const supplementalVideos = maxVideos ? getSupplementVideos(video).slice(0, maxVideos) : getSupplementVideos(video);

  if (!supplementalVideos.length) { return null; }

  const multipleVideos = supplementalVideos.length > 1;

  const itemWrapperClasses = classNames('sui-w-full sui-items-center', {
    'sm:sui-flex': !showDetails
  });

  return (
    <div>
      <div className="sui-flex sui-flex-wrap lg:sui-flex-nowrap" data-testid="educational-summary-desktop-view">
        <div className="sui-flex sui-flex-wrap sui-gap-8 sm:sui-flex-nowrap">
          {
            supplementalVideos.map((supVideo, i) => {
              return (
                <div className={itemWrapperClasses} key={i}>
                  <div className="sui-flex-shrink-0 sui-w-full sm:sui-w-[300px]">
                    <VideoPlayer
                      videoStill={supVideo.videoStill}
                      videoId={supVideo.videoId}
                      width={300}
                      height={150}
                    />
                  </div>
                  <div className="sui-pt-3 sui-w-full sm:sui-w-[300px]">
                    <EducationalInfo
                      title={supVideo.title}
                      shortDescription={supVideo.shortDescription}
                      link={supVideo.link}
                      multiView={multipleVideos || showDetails}
                    />
                  </div>
                </div>
              );
            })
          }
        </div>
        {
          showDetails && (
            <AdditionalDetails itemId={itemId}>
              {children}
            </AdditionalDetails>
          )
        }
      </div>
    </div>
  );
};

EducationalSummaryContent.displayName = 'EducationalSummaryContent';

EducationalSummaryContent.propTypes = {
  itemId: PropTypes.string.isRequired,
  showDetails: PropTypes.bool,
  children: PropTypes.oneOfType([node, arrayOf(node)]),
  maxVideos: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),
  product: PropTypes.shape({
    dataSources: PropTypes.string,
    identifiers: PropTypes.shape({
      productLabel: PropTypes.string
    }),
    media: PropTypes.shape({
      video: arrayOf(PropTypes.shape({
        link: PropTypes.shape({
          text: PropTypes.string,
          url: PropTypes.string
        }),
        shortDescription: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
        videoId: PropTypes.number,
        videoStill: PropTypes.string
      }))
    })
  }).isRequired
};

export { EducationalSummaryContent };
